export const config = {
  base_url : process.env.VUE_BASE_URL
};